import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailMainSwitchboard } from '../dto/trail-main-switchboard';

@Injectable({
  providedIn: 'root'
})
export class TrailMainSwitchboardService {

  private apiUrl = environment.apiRoot + '/trialmainswtichboard';

  constructor(private http: HttpClient) { }

  getAllMSBOfTrial(trialId: number): Observable<TrailMainSwitchboard[]> {
    return this.http.get<TrailMainSwitchboard[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createMainSwitchboard(trialId: number): Observable<TrailMainSwitchboard> {
    let model = { "id": 0, "trial_id": trialId, "name": "new MainSwitchboard" };
    return this.http.post<TrailMainSwitchboard>(this.apiUrl + '/new', model);
  }

  updateMainSwitchboard(model: TrailMainSwitchboard): Observable<TrailMainSwitchboard> {
    return this.http.put<TrailMainSwitchboard>(this.apiUrl + '/update', model);
  }

  deleteMainSwitchboard(trialMsbId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialMsbId=' + trialMsbId);
  }
}
